import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-drone',
  templateUrl: './card-drone.component.html',
  styleUrls: ['./card-drone.component.sass']
})
export class CardDroneComponent implements OnInit {
  @Input() redirectUrl: string;
  @Input() data;
  background_image: any;

  constructor() { }

  ngOnInit(): void {
    this.background_image = 'url(/assets/images/avatar.svg)'
  }
}
